import React, { Suspense } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Model from '../../../../model';
import SlideDown, { SlideDownSkeleton } from 'components/SlideDown';
import { times } from 'utils/render';

const { block } = bem('consultations-faq');

const ConsultationsFAQ = () => {

    const { consultationsFAQData } = Model.faq;

    return (
        <div className={block()}>
            <Suspense fallback={<ItemsBlockSkeleton />}>
                <ItemsBlock resource={consultationsFAQData}/>
            </Suspense>
        </div>
    )
}

const ItemsBlockSkeleton = () => {
    return times((key) => <SlideDownSkeleton key={key} />, 5)
}

const ItemsBlock = ({resource}) => {
    const consultationsFAQ = resource.read();
    return consultationsFAQ.map((faqItem, index) =>
        <SlideDown key={index} answer={faqItem.answer} question={faqItem.question} />
    )
}

export default observer(ConsultationsFAQ);
